import type { ThemeAssets } from 'chessboard/config/theme-assets';
import { Board } from 'chessboard/model/board/types';
import { generateRandomId } from 'src/utils/generate-random-id';

/**
 * Get the default board options.
 */
export function getDefaultOptions(): Board.Options<ThemeAssets.Assets2D> {
  return {
    allowMarkings: true,
    disableUserMarkings: false,
    analysisHighlightColors: {
      alt: Board.HighlightColors.Blue,
      ctrl: Board.HighlightColors.Orange,
      default: Board.HighlightColors.Red,
      shift: Board.HighlightColors.Green,
    },
    analysisHighlightOpacity: 0.8,
    animationType: Board.Animation.Types.Default,
    arrowColors: {
      alt: Board.HighlightedArrowColors.Blue,
      ctrl: Board.HighlightedArrowColors.Red,
      default: Board.HighlightedArrowColors.Orange,
      shift: Board.HighlightedArrowColors.Green,
    },
    aspectRatio: 1,
    autoClaimDraw: true,
    autoPromote: false,
    autoResize: true,
    boardStyle: 'green',
    captureKeyStrokes: true,
    checkBlinkingSquareColor: '#ff0000',
    coordinates: Board.CoordinatesPositions.Inside,
    darkMode: false,
    diagramStyle: true,
    enabled: true,
    disableUserNavigation: false,
    fadeSetup: 0,
    flipped: false,
    highlightColor: undefined,
    highlightLegalMoves: true,
    highlightMoves: true,
    highlightOpacity: 0.5,
    hoverSquareOutline: true,
    id: generateRandomId(),
    moveListContextMenuEnabled: true,
    moveListDisplayType: Board.MoveListDisplayTypes.Text,
    moveListClassificationStyle: Board.MoveListClassificationStyles.Default,
    moveMethod: Board.MoveMethods.Drag,
    overlayInAnalysisMode: false,
    pieceStyle: 'neo',
    playSounds: true,
    premoveDelay: 200,
    premoveHighlightColor: '#f42a32',
    premoveHighlightOpacity: 0.5,
    rounded: true,
    setupImprovements: false,
    soundTheme: 'default',
    syncEffects: true,
    threatSquareColor: '#ff0000',
    threatSquareOpacity: 0.8,
    useSharedStyleTag: false,
    disableRookCastling: false,
    assetPaths: {
      basePath: 'https://www.chess.com',
      enPassant: 'https://www.chess.com/article/view/how-to-capture-en-passant',
      soundsTheme: 'https://images.chesscomfiles.com/chess-themes/sounds/',
    },
  };
}
